import { IOrder } from '@/store/ducks/order/types';

export const useInitiateCheckoutPixel = (order: IOrder) => {
  if (!window.fbq) return;

  window.fbq('track', 'InitiateCheckout', {
    content_ids: order.cart.products.map((product) => product.product_id),
    content_type: 'product',
    contents: order.cart.products.map((product) => ({
      ean: product.ean || '',
      id: product.product_id,
      quantity: product.quantity,
      item_price: product.price,
    })),
    value: order.cart.items_total,
    currency: 'BRL',
    num_items: order.cart.products.length,
  });
};
